{
  "title": "Enrichment logs",
  "columns": {
    "@timestamp": "Date",
    "ci_type_label": "CI Type Name",
    "ci_name": " CI Name",
    "start_time": "Start Time",
    "end_time": "End Time",
    "execution_status": {
      "label": "Execution Status",
      "finished": "Finished",
      "running": "Running"
    },
    "unique_ci_count": "Unique CI Count",
    "doc_count": "Document Count",
    "message": "Message",
    "errors": "Errors",
    "event_type": "Event Type",
    "overall_status": " Status",
    "status": "Status per CIs",
    "duration": "Duration",
    "attribute": "Attribute"
  },
  "views": {
    "grid": "Enrichment Logs",
    "timeline": "Enrichment Tasks"
  },
  "statistics": {
    "srm.statistic.CIEnrichmentSuccess": "CI successfully enriched",
    "srm.statistic.CIEnrichmentError": "CI enrichment error",
    "srm.statistic.CIEnrichmentWarning": "CI enrichment warning",
    "srm.statistic.AttrEnrichmentSuccess": "Attribute successfully enriched",
    "srm.statistic.AttrEnrichmentError": "Attribute enrichment error",
    "srm.statistic.AttrEnrichmentWarning": "Attribute enrichment warning",
    "srm.statistic.LinkEnrichmentSuccess": "Link successfully enriched",
    "srm.statistic.LinkEnrichmentError": "Link enrichment error",
    "srm.statistic.LinkEnrichmentWarning": "Link enrichment warning",
    "statistics.srm.statistic.AdditionalLinkFinished": "Additional link finished"
  }
}